export default function AsciiDivider({ char = "/", label, count = 140 }) {
  const line = char.repeat(count);
  return (
    <div className="ascii-divider py-4 px-4 md:px-8 lg:px-12 font-mono-s text-[10px] md:text-xs" aria-hidden>
      {label ? (
        <div className="flex items-center gap-4">
          <span className="truncate flex-1">{line}</span>
          <span className="shrink-0 uppercase tracking-[0.3em] text-[10px]">{label}</span>
          <span className="truncate flex-1">{line}</span>
        </div>
      ) : (
        <div className="truncate">{line}</div>
      )}
    </div>
  );
}
